<template>
    <div>
        <trip-creator></trip-creator>
    </div>
</template>

<script>
    import TripCreator from '../custom-components/TripCreator.vue'
    
    export default {
        components: {
            'trip-creator': TripCreator
        }
    }
</script>
